export const FETCH_PRODUCT_LISTING_DETAILS_BEGIN = 'FETCH_PRODUCT_LISTING_DETAILS_BEGIN';
export const FETCH_PRODUCT_LISTING_DETAILS_SUCCESS = 'FETCH_PRODUCT_LISTING_DETAILS_SUCCESS';
export const FETCH_PRODUCT_LISTING_DETAILS_FAILURE = 'FETCH_PRODUCT_LISTING_DETAILS_FAILURE';
export const TOGGLE_COMPARE_STATE_FLAG = 'TOGGLE_COMPARE_STATE_FLAG';
export const ADD_PRODUCT_TO_COMPARE = 'ADD_PRODUCT_TO_COMPARE';
export const REMOVE_PRODUCT_FROM_COMPARE = 'REMOVE_PRODUCT_FROM_COMPARE';
export const RESET_COMPARE_DETAILS = 'RESET_COMPARE_DETAILS';
export const SET_SELECTED_BRAND = 'SET_SELECTED_BRAND';
export const RESET_PRODUCT_LISTING_DETAILS = 'RESET_PRODUCT_LISTING_DETAILS';
export const FETCH_PRODUCT_LISTING_DETAILS_SUCCESS_AND_COMPARE = "FETCH_PRODUCT_LISTING_DETAILS_SUCCESS_AND_COMPARE";
export const FETCH_PRODUCT_LISTING_DETAILS_NETWORK_FAILURE = 'FETCH_PRODUCT_LISTING_DETAILS_NETWORK_FAILURE'